export default {
  /**
   * Set the list.
   *
   * @param state
   * @param items
   */
  setEmployeeAwayIndividualEntitlementList(state, items) {
    console.log("Set items", items);
    state.items = items;
  },

  /**
   *
   * @param state
   * @param pagination
   */
  setEmployeeAwayIndividualEntitlementListPagination(state, pagination) {
    console.log("Pagination ", pagination);
    state.pagination = pagination;
  },

  /**
   * Set Teacher individual entitlement form.
   *
   * @param state
   * @param form
   */
  setEmployeeAwayIndividualEntitlementForm(state, form) {
    console.log("Form ", form);
    state.form = form;
    state.form.employee_id = form.employee_id;
  },

  /**
   *
   * @param state
   * @param page
   */
  setEmployeeAwayIndividualEntitlementListPage(state, page) {
    console.log("Pagination ", page);
    state.pagination.current_page = page;
  },
};
